import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import TextField from '@material-ui/core/TextField'
import Snackbar from '@material-ui/core/Snackbar'
import Fade from '@material-ui/core/Fade'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

import DBHelper from '../../helpers/db'
import XLSX from 'xlsx'
import _ from 'lodash'


const Styles = {
  container: {
    margin: 30,
    marginTop: 100,
    display: 'flex',
    flexDirection: 'column'
  },
  form: {
    padding: 20,
    display: 'flex',
    flexDirection: 'column'
  },
  textField: {
    width: 400,
    paddingBottom: 20
  },
  snackbar: {
    margin: 40
  }
}

export class NewSpaceScreen extends Component {

  constructor(props) {
    super(props)
    
    this.state = {
      spaceId: '',
      title: '',
      prefix: '',
      users: [],
      groups: [],
      error: {},
      snackbarMessage: '',
      snackbarOpen: false
    }

  }


  handleChange = event => {

    const { id, value } = event.target

    const { error } = this.state

    switch(id) {
      case 'spaceId':
        error[id] = this.validateValueLength(id, value, 4)
        break
      case 'title':
        error[id] = this.validateValueLength(id, value, 5)
        break
      case 'prefix':
        error[id] = this.validateValueLength(id, value, 3)
        break

      default:
        // do nothing
    }

    this.setState({
      [id]: value,
      error
    });
  }

  validateValueLength = (id, value, length) => {
    const error = this.state.error
    if(value.length > length) {
      error[id] = ''
      this.setState({error})
      return true
    } else {
      error[id] = `${id} should be longer than ${length}`
      this.setState({error})
      return false
    }
  }

  validate = () => {
    const { spaceId, title, prefix } = this.state
    const validated = this.validateValueLength('spaceId', spaceId, 4) &&
    this.validateValueLength('title', title, 5) &&
    this.validateValueLength('prefix', prefix, 3)
    return validated
  }

  handleSubmit = (event) => {
    this.setState({saving: true})
    const { spaceId, title, prefix, users, groups } = this.state

    if(this.validate()) {
      DBHelper.saveApplication({spaceId, title, prefix, users, groups})
      .then(() => {
        this.setState({
          spaceId: '',
          title: '',
          prefix: '',
          users: [],
          groups: [],
          error: {},
          saving: false,
          snackbarMessage: '성공적으로 저장되었습니다.',
          snackbarOpen: true
        })
      })
    } else {
      this.setState({
        saving: false,
        snackbarMessage: '입력값을 확인해주세요.',
        snackbarOpen: true
      })
    }

    event.preventDefault();
  }

  handleFile = (event) => {
    const input = event.target.files[0]
    const reader = new FileReader()

    const context = this

    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, {type: 'binary'})
      workbook.SheetNames.forEach(function(sheetName) {
        // Here is your object
        const XL_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
        const users = XL_row_object;
        console.log(`users = ${users}`)
        const groups = _.uniq(users.map(user => user.group))
        const snackbarMessage = `${users.length} user(s) and ${groups.length} group(s) are loaded.`
        context.setState({
          users,
          groups,
          snackbarMessage,
          snackbarOpen: true
        })
      })
    }

    reader.onerror = function(ex) {
      console.log(ex);
    };


    reader.readAsBinaryString(input)
    // const workbook = XLSX.readFile(file.name, {type: 'file'})
    
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    this.setState({ snackbarMessage: '', snackbarOpen: false });
  };

  render() {

    const { spaceId, title, prefix, error } = this.state

    return (
      <div style={Styles.container}>
        <h1>Create a new space</h1>
        <form style={Styles.form} onSubmit={this.handleSubmit}>
        <TextField
            id='spaceId'
            label='Space Id'
            placeholder='Unique spaceId'
            style={Styles.textField}
            error={!error['spaceId']}
            value={spaceId}
            onChange={this.handleChange}
            required
          />

          <TextField
            id='title'
            label='Title'
            placeholder='How we call your space?'
            style={Styles.textField}
            error={!error['title']}
            value={title}
            onChange={this.handleChange}
            required
          />

          <TextField
            id='prefix'
            label='Prefix'
            placeholder="Your space's short nickname"
            style={Styles.textField}
            error={!error['prefix']}
            value={prefix}
            onChange={this.handleChange}
            required
          />

          <input type="file" id="applicationFile" style={Styles.textField} onChange={this.handleFile}/>

          <Button
            variant="contained"
            color="primary"
            disabled={this.state.validated}
            fullWidth={true}
            onClick={this.handleSubmit}>
            {this.state.saving
            ? 'Saving'
            : 'Submit'}
          </Button>

        </form>

        <Snackbar
          open={this.state.snackbarOpen}
          onClose={this.handleClose}
          autoHideDuration={6000}
          TransitionComponent={Fade}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{this.state.snackbarMessage}</span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  
})

const mapDispatchToProps = {
  
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewSpaceScreen))



// WEBPACK FOOTER //
// ./src/components/spaces/NewSpaceScreen.js